import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    rigaDocumento: null,
    saved: false
  },
  getters: {
    rigaDocumento: state => state.rigaDocumento,
    saved: state => state.saved
  },
  mutations: {
    SET_RIGA_DOCUMENTO (state, payload) {
      state.rigaDocumento = payload
    },
    CLEAR_RIGA_DOCUMENTO (state) {
      state.rigaDocumento = null
    },
    SET_RIGA_DOCUMENTO_SAVED (state) {
      state.saved = true
    },
    CLEAR_RIGA_DOCUMENTO_SAVED (state) {
      state.saved = false
    }
  },
  actions: {
  }
}
